import * as React from "react";
import { ScoreboardCellScore, ScoreboardCellContent } from "../ScoreboardCell";
export class ScoreboardRow extends React.PureComponent {
    render() {
        return (React.createElement("tr", { className: "rj-aggregate-scoreboard-row" }, Object.keys(this.props.scoresData).map(scoreKey => (scoreKey === "name"
            ? React.createElement(ScoreboardCellContent, { key: `${this.props.scoresData.participantScoreId}-${scoreKey}`, content: this.props.scoresData[scoreKey], columnClass: "" })
            : scoreKey !== "participantScoreId" && React.createElement(ScoreboardCellScore, { key: `${this.props.scoresData.participantScoreId}-${scoreKey}`, content: this.props.scoresData[scoreKey] })))));
    }
}
//# sourceMappingURL=ScoreboardRow.js.map